import React from "react";
import { Input, Button, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export const searchFilterDropdown = (placeholder, filterKey, updateFiltro) =>
  ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        placeholder={placeholder}
        value={selectedKeys[0]}
        onChange={(e) => {
          const value = e.target.value;
          setSelectedKeys(value ? [value] : []);
          updateFiltro({ [filterKey]: value });
          confirm({ closeDropdown: false });
        }}
        onPressEnter={() => confirm()}
        style={{ marginBottom: 8, display: "block" }}
      />
      <Space>
        <Button type="primary" onClick={() => confirm()} icon={<SearchOutlined />} size="small">
          Buscar
        </Button>
        <Button
          onClick={() => {
            clearFilters();
            updateFiltro({ [filterKey]: "" });
            confirm();
          }}
          size="small"
        >
          Limpiar
        </Button>
      </Space>
    </div>
  );
